<template>
  <svg :width="width" :height="height" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.37977 11.7089C4.37977 11.3067 4.37392 10.9044 4.3827 10.5029C4.38562 10.3559 4.34686 10.2799 4.20059 10.2199C3.0063 9.73355 1.81567 9.23769 0.625768 8.74111C0.171601 8.55169 -0.0426856 8.21819 0.00704605 7.77646C0.0436134 7.45613 0.230839 7.23453 0.505826 7.07802C1.70085 6.39641 2.89514 5.71333 4.09016 5.03025C6.89195 3.42933 9.69374 1.82841 12.4948 0.226761C12.7566 0.0768352 13.0163 -0.0570014 13.338 0.0249096C13.7015 0.117791 14.0182 0.447628 13.9992 0.820616C13.9758 1.2682 13.9048 1.71432 13.8383 2.15898C13.616 3.63265 13.387 5.10558 13.1603 6.57925C12.9219 8.12458 12.6835 9.66992 12.4451 11.2153C12.3902 11.57 12.3324 11.9247 12.2842 12.2801C12.1876 12.9851 11.6048 13.3186 10.9465 13.0407C9.9936 12.6392 9.03846 12.2413 8.08844 11.8332C7.94802 11.7733 7.88 11.7996 7.79004 11.9166C7.37464 12.4578 6.95265 12.9932 6.52481 13.5241C6.16499 13.971 5.63038 14.1472 5.15866 13.9468C4.71327 13.7574 4.40098 13.4349 4.38855 12.9134C4.37904 12.5119 4.38635 12.1097 4.38635 11.7075C4.38489 11.7075 4.3827 11.7075 4.38123 11.7075L4.37977 11.7089ZM11.3978 12.2794C11.928 8.83253 12.4546 5.40763 12.9812 1.98346C12.9694 1.97761 12.957 1.97176 12.9453 1.96591C10.5011 4.59217 8.05699 7.21844 5.5982 9.86007C7.54358 10.6719 9.45752 11.4698 11.3985 12.2794H11.3978ZM0.856871 7.87958C0.927812 7.91688 0.962918 7.93809 0.999485 7.95345C2.20548 8.45515 3.4122 8.95393 4.616 9.46075C4.74179 9.51341 4.80103 9.46587 4.87709 9.38469C7.31833 6.75623 9.76103 4.12923 12.203 1.5015C12.2323 1.47005 12.2557 1.43275 12.2813 1.39838C12.2739 1.39107 12.2666 1.38375 12.2586 1.37644C8.46947 3.53757 4.68109 5.69797 0.856139 7.87958H0.856871ZM5.253 10.6529C5.24569 10.7157 5.23837 10.7509 5.23837 10.786C5.23837 11.4434 5.23691 12.1017 5.23837 12.7591C5.23837 12.9251 5.27202 13.0817 5.45705 13.1387C5.6355 13.1936 5.7591 13.1014 5.86441 12.9683C6.24252 12.4915 6.62282 12.0161 7.00092 11.5392C7.02871 11.5041 7.04919 11.4632 7.07844 11.4156C6.46704 11.1604 5.87318 10.9125 5.25227 10.6529H5.253Z" :fill="color"/>
  </svg>
</template>

<script>
export default {
  name: 'PeopleIcon',
  props: {
    width: {
      type: Number,
      default: 15
    },
    height: {
      type: Number,
      default: 24
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>

<style>

</style>
